export const HOMEWORK_REQUEST = "homeworkReducer/HOMEWORK_REQUEST";
export const HOMEWORK_SUCCESS = "homeworkReducer/HOMEWORK_SUCCESS";
export const HOMEWORK_FAILED = "homeworkReducer/HOMEWORK_FAILED";
export const HOMEWORK_RESET = "homeworkReducer/HOMEWORK_RESET";
export const HOMEWORK_SEARCH = "homeworkReducer/HOMEWORK_SEARCH";

export const HOMEWORK_DETAIL_REQUEST = "homeworkDetailReducer/HOMEWORK_DETAIL_REQUEST";
export const HOMEWORK_DETAIL_SUCCESS = "homeworkDetailReducer/HOMEWORK_DETAIL_SUCCESS";
export const HOMEWORK_DETAIL_FAILED = "homeworkDetailReducer/HOMEWORK_DETAIL_FAILED";
export const HOMEWORK_DETAIL_RESET = "homeworkDetailReducer/HOMEWORK_DETAIL_RESET";

export const DOCUMENT_REQUEST = "documentReducer/DOCUMENT_REQUEST";
export const DOCUMENT_SUCCESS = "documentReducer/DOCUMENT_SUCCESS";
export const DOCUMENT_FAILED = "documentReducer/DOCUMENT_FAILED";
export const DOCUMENT_RESET = "documentReducer/DOCUMENT_RESET";
export const DOCUMENT_SEARCH = "documentReducer/DOCUMENT_SEARCH";

export const DOCUMENT_DETAIL_REQUEST = "documentDetailReducer/DOCUMENT_DETAIL_REQUEST";
export const DOCUMENT_DETAIL_SUCCESS = "documentDetailReducer/DOCUMENT_DETAIL_SUCCESS";
export const DOCUMENT_DETAIL_FAILED = "documentDetailReducer/DOCUMENT_DETAIL_FAILED";
export const DOCUMENT_DETAIL_RESET = "documentDetailReducer/DOCUMENT_DETAIL_RESET";

export const CREATE_HOMEWORK_REQUEST = "createHomeworkReducer/CREATE_HOMEWORK_REQUEST";
export const CREATE_HOMEWORK_SUCCESS = "createHomeworkReducer/CREATE_HOMEWORK_SUCCESS";
export const CREATE_HOMEWORK_FAILED = "createHomeworkReducer/CREATE_HOMEWORK_FAILED";
export const CREATE_HOMEWORK_RESET = "createHomeworkReducer/CREATE_HOMEWORK_RESET";

export const CREATE_DOCUMENT_REQUEST = "createDocumentReducer/CREATE_DOCUMENT_REQUEST";
export const CREATE_DOCUMENT_SUCCESS = "createDocumentReducer/CREATE_DOCUMENT_SUCCESS";
export const CREATE_DOCUMENT_FAILED = "createDocumentReducer/CREATE_DOCUMENT_FAILED";
export const CREATE_DOCUMENT_RESET = "createDocumentReducer/CREATE_DOCUMENT_RESET";


